import React from 'react';
import Sectiontitle from '../section-title';
import { useSiteSettings } from '../../siteSettings';
import apiRequest from '../../admin/services/apiClient';
import AdminToast from '../../admin/components/AdminToast';
import './style.css';

const Rsvp = () => {
    const settings = useSiteSettings();
    const eventSection = settings.eventSection || {};
    const eventItems = eventSection.items || [];
    const [form, setForm] = React.useState({ name: '', email: '', rsvp: '', events: '', notes: '' });
    const [error, setError] = React.useState({});
    const [success, setSuccess] = React.useState('');
    const [sending, setSending] = React.useState(false);

    const changeHandler = (event) => {
        setForm({ ...form, [event.target.name]: event.target.value });
        setError({ ...error, [event.target.name]: '' });
    };

    const submitHandler = async (event) => {
        event.preventDefault();
        const nextError = {};
        if (!form.name) nextError.name = 'Veuillez saisir votre nom';
        if (!form.email) nextError.email = 'Veuillez saisir votre adresse e-mail';
        if (!form.rsvp) nextError.rsvp = 'Veuillez sélectionner le nombre d’invités';
        if (!form.events) nextError.events = 'Veuillez sélectionner votre participation';
        if (!form.notes) nextError.notes = 'Veuillez saisir un message';
        setError(nextError);
        setSuccess('');
        if (Object.keys(nextError).length) return;

        setSending(true);
        try {
            const selectedEvent = form.events === 'all' ? 'Tous les événements' : (eventItems[Number(form.events) - 1] || {}).title || form.events;
            await apiRequest('/rsvp.php', {
                method: 'POST',
                body: JSON.stringify({
                    name: form.name,
                    email: form.email,
                    guest_count: Number(form.rsvp),
                    event_selection: selectedEvent,
                    message: form.notes,
                }),
            });
            setForm({ name: '', email: '', rsvp: '', events: '', notes: '' });
            setSuccess('Votre réponse a bien été envoyée.');
            setError({});
        } catch (requestError) {
            setError({ submit: requestError.message });
        } finally {
            setSending(false);
        }
    };

    return (
        <div id="rsvp" className="rsvp-area go-rsvp-area section-padding">
            <AdminToast message={success} type="success" onClose={() => setSuccess('')} />
            <AdminToast message={error.submit} type="danger" onClose={() => setError({ ...error, submit: '' })} />
            <Sectiontitle section={'Confirmez votre présence'} />
            <div className="container"><div className="row"><div className="col-lg-8 offset-lg-2 col-md-10 offset-md-1"><div className="rsvp-wrap">
                <form onSubmit={submitHandler}>
                    <div className="contact-form form-style">
                        <div className="col-12 col-sm-12"><input type="text" value={form.name} onChange={changeHandler} placeholder="Votre nom *" id="fname" name="name" /><p>{error.name || ''}</p></div>
                        <div className="col-12 col-sm-12"><input type="text" placeholder="Votre e-mail *" onChange={changeHandler} value={form.email} id="email" name="email" /><p>{error.email || ''}</p></div>
                        <div className="col col-sm-12"><input className="form-control" type="number" min="1" onChange={changeHandler} value={form.rsvp} placeholder="Nombre d’invités *" name="rsvp" /><p>{error.rsvp || ''}</p></div>
                        <div className="col col-sm-12"><select className="form-control" onChange={changeHandler} value={form.events} name="events"><option disabled value="">Je participerai à *</option><option value="all">Tous les événements</option>{eventItems.map((item, index) => <option key={`${item.title}-${index}`} value={String(index + 1)}>{item.title}</option>)}</select><p>{error.events || ''}</p></div>
                        <div className="col-12 col-sm-12"><textarea className="contact-textarea" value={form.notes} onChange={changeHandler} placeholder="Votre message" name="notes"></textarea><p>{error.notes || ''}</p></div>
                        <div className="col-12 text-center"><button id="submit" type="submit" className="submit" disabled={sending}>{sending ? 'Envoi…' : 'Envoyer ma réponse'}</button></div>
                    </div>
                </form>
            </div></div></div></div>
        </div>
    );
};

export default Rsvp;
